import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";
import { PostLeagueDivision, TPostLeagueDivision } from "api/rpc/2024-04/facilityAdmin/league/scoring/division";
import { useAppDispatch } from "hooks/redux";
import { showError, showSuccess } from "redux/actions/ui";

import Page from "components/page/Page";
import Form from "components/form/Form";
import Card from "components/card/Card";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";

export default function LeagueDivisionsNew() {
  const history = useHistory();
  const { t } = useTranslation();
  const { leagueId } = useParams<{ leagueId: string }>();

  const dispatch = useAppDispatch();

  const [division, setDivision] = useState<Omit<TPostLeagueDivision, "league_id">>({
    title: "",
  });

  // TODO: Typesafety
  async function createDivision(params: TPostLeagueDivision) {
    const res = await PostLeagueDivision({ league_id: leagueId, ...params }, true);
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating new division")));
      return;
    }

    dispatch(showSuccess(t("Successfully created new division")));
    history.push(`/admin/league/${leagueId}/divisions`);
  }

  const primaryAction = {
    content: t("Create"),
    action: () => createDivision({ league_id: leagueId, ...division }),
    // disabled: !flightState.name ? true : false,
  };

  return (
    <Page
      title={t("New Division")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Divisions"),
          url: `/admin/league/${leagueId}/divisions`,
        },
      ]}
    >
      <Form>
        <Card title={t("Division Details")}>
          {" "}
          <Card.Section>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  value={division.title ?? ""}
                  label={t("Name")}
                  id="name"
                  onChange={e => setDivision(prev => ({ ...prev, title: e.target.value }))}
                  placeholder={t("Division name")}
                />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      </Form>
    </Page>
  );
}
